import React, { useState } from "react";
import { FaGreaterThan } from "react-icons/fa6";
import { toast } from "react-toastify";
import { updateCampaignAssociateStatus } from "../../../../services/ApiService";
import { getPlatformImg } from "../../../../helpers/getImgSrc";
import { useNavigate } from "react-router-dom";
import { ConfirmModal } from "../../../../components/ConfirmModal";
import { getImgSrc } from "../../../../helpers/getImgSrc";

const CampaignSocialMediaCard = ({ asociatedAd,getCampaignList }) => {
  const [disassociating, setDisassociating] = useState(false);
  const [disassociateConfirmModal, setDisassociateConfirmModal] =
    useState(false);
  const navigate = useNavigate();
  const [adImage,setAdImage]=useState(asociatedAd?.image_url)

  const disassociateCampaing = async (asociatedAd) => {
    setDisassociating(true);
    let formData = new FormData();
    try {
      formData.append(
        "campaign_id",
        parseInt(asociatedAd?.internal_campaign_id)
      );
      formData.append("platform_id", asociatedAd?.platform_id);
      formData.append("ads_id", asociatedAd?.ads_id);
      formData.append(
        "external_campaign_id",
        asociatedAd?.external_campaign_id
      );
      formData.append("is_mapped", asociatedAd?.is_mapped);
      const response = await updateCampaignAssociateStatus(formData);
      if (response?.success) {
        toast.success(
          response?.message || "Campaign Disassociated Successfully"
        );
        getCampaignList()
      } else {
        toast.error(response?.error?.error_message || "Something went wrong");
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setDisassociating(false);
    }
  };
  
  return (
    <div className="row px-1 py-3 campaign_item_card" key={asociatedAd?.ads_id}>
      <div className="col-md-2 position-relative" style={{height:'7rem'}}>
        {asociatedAd?.image_url ?<img className="campaign_item_card_poster position-relative w-100" src={adImage?adImage:getImgSrc('no_image_found','png')} 
         onError={()=>{
          setAdImage('')
         }}
        /> : 
        <div className="campaign_item_card_poster position-relative w-100">
        </div>}
        {/* <div className="campaign_item_card_poster position-relative w-100">
        </div> */}
      </div>
      <div className="col-md-10">
        <div className="d-flex flex-wrap justify-content-between  my-2 pb-2  border_bottom ">
          <div className="d-flex align-items-center gap-2 ">
            <img
              src={getPlatformImg(asociatedAd?.platform_id)}
              className="img-fluid social_media_img"
              alt=""
            />

            <p className="mb-0 text_color_secondary">
              {asociatedAd?.data?.name ?? "Ad Name"}
            </p>
          </div>
          <span>{asociatedAd?.platform_name || ""} Platform</span>
        </div>
        <div className="row d-flex align-items-center mt-2 g-2">
          <div className="col-lg-2 col-md-4 col-6">
            <div className="d-flex gap-2">
              <p className="mb-0">
                $ {Number(String(asociatedAd?.spent).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}
              </p>
            </div>
            <span>Total Spent</span>
          </div>
          <div className="col-lg-2 col-md-4 col-6">
            <div className="d-flex gap-2">
              <p className="mb-0">
                 {Number(String(asociatedAd?.impressions).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}
              </p>
            </div>
            <span>Impressions</span>
          </div>
          <div className="col-lg-2 col-md-4 col-6">
            <div className="d-flex gap-2">
              <p className="mb-0">  {Number(String(asociatedAd?.clicks).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</p>
            </div>
            <span>Clicks</span>
          </div>
          <div className="col-lg-2 col-md-4 col-6">
            <div className="d-flex gap-2">
              <p className="mb-0">
                {" "}
                {Number(String(asociatedAd?.ctr).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}
              </p>
            </div>
            <span>CTR</span>
          </div>
          <div className=" col-md-4 col-12 d-flex gap-3 justify-content-end">
            <button
              disabled={disassociating}
              onClick={() => {
                setDisassociateConfirmModal(true);
              }}
              className="btn_small_primary"
            >
              {disassociating ? "Please wait..." : "Disassociate"}
            </button>

            <button
              onClick={() => {
                navigate(`/client/campaigns/view-more/${asociatedAd?.ads_id}/${asociatedAd?.platform_id}`);
              }}
              className="btn_small_primary"
            >
              View More <FaGreaterThan />
            </button>
          </div>
        </div>
      </div>

      <ConfirmModal
        show={disassociateConfirmModal}
        onClose={() => setDisassociateConfirmModal(false)}
        title={"Disassociate Ad"}
        body={
          "Are you sure you want to disassociate this external Ad ? You can re-associate it later from the Link Campaigns section."
        }
        closeBtnTitle={"Cancel"}
        submitBtnTitle={"Continue"}
        onSubmit={() => disassociateCampaing(asociatedAd)}
        loadingOnsubmit={disassociating}
      />
    </div>
  );
};

export default CampaignSocialMediaCard;
